angular.module('NumbersEditor').controller('PreDrawWeightController', [
    '$scope', '$routeParams', '$rootScope', 'EventFactory', '$location', '$filter', '$dialogs',
    function ($scope, $routeParams, $rootScope, eventFactory, $location, $filter, $dialogs) {
        function init() {
            $scope.SportCode = $routeParams.sportCode === "49" ? "49" : "Irish Lottery";
            $scope.Adjudicator = {
                FirstName: "",
                LastName: ""
            }
            eventFactory.GetEventExtraInfo($routeParams.eventId, 0)
                .success(function (data) {
                    $scope.EventExtraInfo = data;
                    $scope.SelectedBallSet = parseInt(data.SetOfBalls);
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        function getSubTitle() {
            var sportCode = $routeParams.sportCode === "49" ? "49" : "Irish Lottery";
            var eventNo = parseInt($routeParams.no);
            var draw = "";
            if (sportCode === "49" && eventNo === 1)
                draw = "Lunch Time";
            else if (sportCode === "49" && eventNo === 2)
                draw = "Tea Time";
            var date = $filter("date")($routeParams.startDate, "fullDate");

            return sportCode + " - " + draw + " - (" + date + ")";
        }

        $rootScope.SetAppTitle("Pre-Draw", getSubTitle());

        init();

        $scope.Save = function () {
            var adjudicatorFirstName = $scope.Adjudicator.FirstName.trim();
            var adjudicatorLasttName = $scope.Adjudicator.LastName.trim();
            $scope.EventExtraInfo.AdjudicatorName = adjudicatorFirstName + " " + adjudicatorLasttName;
            eventFactory.SaveEventExtraInfo($routeParams.eventId, $scope.EventExtraInfo)
                .success(function () {
                    $.message(MessageText.EventExtraInfoSuccessfullySaved, MessageType.Success);
                    $location.path("/certificate/" + $routeParams.eventId);
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.UpdateBallSet = function (selectedBallSet) {
            eventFactory.GetEventExtraInfo($routeParams.eventId, parseInt(selectedBallSet))
                .success(function (data) {
                    $scope.EventExtraInfo = data;
                    $scope.SelectedBallSet = selectedBallSet;
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.GoToManageGame = function () {
            $dialogs.confirm("Changes will be lost",
                "Are you sure?",
                function () {
                    $location.path("game/" + localStorage.getItem("GameId"))
                        .search({ sportCode: $routeParams.sportCode, startDate: $routeParams.startDate });
                });
        };
    }
]);